<template>
  <div class="w-full">
    <label v-if="label" class="form-label mb-2">
      {{ label }}
    </label>

    <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
      <!-- ALL option:start -->
      <div class="form-check">
        <input
          id="age-all"
          type="checkbox"
          class="form-check-input"
          :checked="isAllActive"
          @change="toggleAll($event.target.checked)"
        />

        <label for="age-all" class="form-check-label">
          {{ $t(`globals.ages_ranges.${allKey}`) }}
        </label>
      </div>
      <!-- ALL option:end -->

      <!-- Individual options:start -->
      <template v-for="(ageGroup, ageGroupKey) in agesGroups" :key="ageGroupKey">
        <div class="form-check">
          <input
            :id="`age-${ageGroupKey}`"
            type="checkbox"
            class="form-check-input"
            :checked="isAllActive ? true : selectedSet.has(ageGroup)"
            @change="toggleOne(ageGroup, $event.target.checked)"
          />

          <label class="form-check-label" :for="`age-${ageGroupKey}`">
            {{ $t(`globals.ages_ranges.${ageGroup}`) }}
          </label>
        </div>
      </template>
      <!-- Individual options:end -->
    </div>

    <div v-if="error" class="text-theme-6 mt-2">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: "AgeRangesSelect",
  props: {
    modelValue: { type: Array, default: () => [] },
    label: { type: String, default: "" },
    error: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      allKey: "ALL",
      agesGroups: this.$global.getAgesRanges().filter((k) => k !== "ALL"),
    };
  },
  computed: {
    // Is the special "ALL" mode active?
    isAllActive() {
      return this.modelValue.includes(this.allKey);
    },
    // Current selected set (without ALL). If ALL active, treat as all groups selected.
    selectedSet() {
      return this.isAllActive ? new Set(this.agesGroups) : new Set(this.modelValue.filter((v) => v !== this.allKey));
    },
  },
  methods: {
    // Toggle the "ALL" checkbox
    toggleAll(checked) {
      // If ALL is checked, compress to ["ALL"]; if unchecked, clear all.
      this.$emit("update:modelValue", checked ? [this.allKey] : []);
    },
    // Toggle a single age group
    toggleOne(age, checked) {
      // Start from the visual truth
      const next = new Set(this.selectedSet);

      // When ALL is active and the user unchecks any item,
      // we must exit ALL mode and keep only the remaining checked ones.
      if (this.isAllActive) {
        if (!checked) next.delete(age);
        // Emit concrete list (no ALL)
        return this.$emit("update:modelValue", Array.from(next));
      }

      // Normal mode: add/remove the clicked item
      if (checked) next.add(age);
      else next.delete(age);

      // If user ended up selecting all groups manually, compress to ["ALL"]
      if (next.size === this.agesGroups.length) {
        this.$emit("update:modelValue", [this.allKey]);
      } else {
        this.$emit("update:modelValue", Array.from(next));
      }
    },
  },
};
</script>
